module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-2200.01cb908c.svg";